/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Work_0_Metric_2_LabelInputs */

const en_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost / session`)
};

const ar_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التكلفة لكل جلسة`)
};

const bn_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খরচ / সেশন`)
};

const de_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten/Sitzung`)
};

const es_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costo/sesión`)
};

const fr_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coût / séance`)
};

const pt_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custo/sessão`)
};

const zh_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成本/会话`)
};

const tr_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maliyet / oturum`)
};

const ru_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость/сеанс`)
};

const pl_svc_ai_integration_work_0_metric_2_label = /** @type {(inputs: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koszt/sesja`)
};

/**
* | output |
* | --- |
* | "Cost / session" |
*
* @param {Svc_Ai_Integration_Work_0_Metric_2_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_work_0_metric_2_label = /** @type {((inputs?: Svc_Ai_Integration_Work_0_Metric_2_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Work_0_Metric_2_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "bn") return bn_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "de") return de_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "es") return es_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "fr") return fr_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "pt") return pt_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "zh") return zh_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "tr") return tr_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "ru") return ru_svc_ai_integration_work_0_metric_2_label(inputs)
	if (locale === "pl") return pl_svc_ai_integration_work_0_metric_2_label(inputs)
	return en_svc_ai_integration_work_0_metric_2_label(inputs)
});
export { svc_ai_integration_work_0_metric_2_label as "svc_ai-integration_work_0_metric_2_label" }